import { useContext } from 'react';
import { DialogContext } from '../../../../store/context/DialogContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import BusinessV2SectionedFieldStep from './components/BusinessV2SectionedFieldStep';
import { collectVisibleFieldErrors, getFieldErrorValue, getNextStepV2, getVisibleWizardFieldOrder } from './helperV2';

const ComplianceDetails = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    editMode,
    jsonConfig,
    pageNum = 1,
}) => {
    const { showError } = useContext(DialogContext);
    const applicationType = Number(applicationForm?.type);
    const wizardContent = jsonConfig?.wizardContent?.[wizard] || {};
    const visibleFieldOrder = getVisibleWizardFieldOrder({
        fields: iPlusFields,
        wizard,
        data,
        type: applicationType,
    });

    const checkNext = () => {
        const { fieldErrors } = collectVisibleFieldErrors({
            data,
            step: { wizard },
            iPlusFields,
            errors,
            type: applicationType,
        });
        const mergedErrors = {
            ...(errors || {}),
            ...fieldErrors,
        };
        setErrors(mergedErrors);

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = getFieldErrorValue(mergedErrors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }

        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            const nextStep = applicationForm?.getNextStepForForm?.({ wizard, data, editMode })
                || getNextStepV2(wizard, applicationType, data, jsonConfig, { editMode });
            return handleUpdate({ nextStep });
        }
    };

    return (
        <div className="business-v2-step-shell" data-testid="business-v2-compliance-details-step">
            <BusinessV2SectionedFieldStep
                title='Compliance'
                titleIcon='program'
                wizardContent={wizardContent}
                visibleFieldOrder={visibleFieldOrder}
                fieldMap={cyclosFields}
                data={data}
                asLabel={asLabel}
                handleChange={handleChange}
                hasError={hasError}
                onFieldError={(field, errorMsg) => setErrors((prevErrors) => ({ ...(prevErrors || {}), [field]: errorMsg }))}
                dataTestIdPrefix='business-v2-compliance-details'
            />

            <div className='business-v2-step-actions'>
                <ButtonGroupNew
                    onNextClick={handleSubmit}
                    onBackClick={() => { handlePrev() }}
                    step={pageNum}
                    hideSubmitButton={hideButtons}
                    asLabel={false}
                    loading={loading}
                    showPageNum={false}
                    pageNum={pageNum}
                />
            </div>
        </div>
    );
};

export default ComplianceDetails;
